<i18n>
{
  "en": {
    "side-nav": {
      "login": "Login"
    },
    "main-nav": {
      "recent": "Recent",
      "favorite": "Favorites"
    }
  },
  "de": {
    "side-nav": {
      "login": "Login"
    },
    "main-nav": {
      "recent": "Vorherige",
      "favorite": "Favoriten"
    }
  }
}
</i18n>

<template>
  <v-app>

    <Header/>

    <!--<keep-alive>-->
      <!--<transition name="fade" mode="out-in">-->
      <router-view />
      <!--</transition>-->
    <!--</keep-alive>-->

    <!-- Bottom nav bar -->
    <!--
    <v-bottom-navigation grow v-model="bottomNav" app>
      <v-btn value="recent" to="/recent">
        <span>{{ $t('main-nav.recent') }}</span>
        <v-icon>mdi-history</v-icon>
      </v-btn>
      <v-btn value="favorites" to="/favorite">
        <span>{{ $t('main-nav.favorite') }}</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>
    </v-bottom-navigation>
    -->
    <Footer/>
    <GSNWelcome :value="welcomeDialog"/>
  </v-app>
</template>

<script>
import {settingsMixin} from '@/utils/settings-mixin'
import Header from '@/views/website/Header.vue'
import Footer from '@/views/website/Footer.vue'
import GSNWelcome from '@/components/ui/GSNWelcome.vue'

export default {
  mixins: [settingsMixin],
  components:{
    Header,
    Footer,
    GSNWelcome
  },
  data () {
    return {
      welcomeDialog:true,
      bottomNav: 'recent',
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style>
/*
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .15s;
}

.fade-enter-active {
  transition-delay: .15s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
*/

</style>